export default reducer => reducer(undefined, {});
